export default function (params) {
    return !!params.clientId
        && !!params.state
        && !!params.redirectUri
        && !!params.responseType
        && !!params.scopes.length > 0;
}